import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { Delivery } from '../types/delivery';
import { DataFetchError } from '../../utils/ErrorClass';
import { useAuthContext } from '../auth/AuthContext';

const useDelivery = () => {
  const [deliveries, setDeliveries] = useState<Delivery[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const { state } = useAuthContext();

  const fetchDeliveries = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('delivery')
        .select('*, customer(*)')
        .eq('customer_id', state.customerId)
        .order('delivery_date', { ascending: false });

      if (error) {
        throw new DataFetchError(error.message);
      }

      setDeliveries(data as Delivery[]);
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [state.customerId]);

  useEffect(() => {
    fetchDeliveries();
  }, [fetchDeliveries]);

  return { deliveries, loading, error };
};

export default useDelivery;
